import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { ProductOverview } from './components/ProductOverview';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { MoreTestimonials } from './components/MoreTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    window.fbq('init', '1668014427688483');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark text-gray-900 font-sans selection:bg-brand-accent/30 selection:text-gray-900" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1668014427688483&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Hero data-id="element-3" />
      <SocialProof data-id="element-4" />
      <Testimonials data-id="element-5" />
      <ProblemSection data-id="element-6" />
      <ProductOverview data-id="element-7" />
      <TomosSection data-id="element-8" />
      <BonusesSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <ComparisonTable data-id="element-11" />
      <MoreTestimonials data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <FAQSection data-id="element-14" />
      <CostOfInaction data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}